import React, {createContext, useState} from "react";

type AppSettingsContext = {
    isParallel: boolean;
    setIsParallel: (turnOn: boolean) => void;
    isLab: boolean;
    setIsLab: (val: boolean) => void;
};

export const AppSettingsContext = createContext<AppSettingsContext>({
    isParallel: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsParallel: () => {},
    isLab: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsLab: () => {},
});

export function AppSettingsProvider(props: {children: React.ReactNode}) {
    const [isParallel, setIsParallel] = useState(false);
    const [isLab, setIsLab] = useState(false);

    return (
        <AppSettingsContext.Provider
            value={{
                isParallel,
                setIsParallel,
                isLab,
                setIsLab,
            }}>
            {props.children}
        </AppSettingsContext.Provider>
    );
}
